import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  Helmet: lazyNamed(() => import('./Helmet'), 'Helmet'),
  AiChat: lazyNamed(() => import('./pages/Chat'), 'AiChat'),
  AiImageContext: lazyNamed(() => import('./pages/Image/ContextWrapper'), 'ContextWrapper'),
  AiImageModels: lazyNamed(() => import('./pages/Image/ModelSelector'), 'AiImageModels'),
  AiImageGenerator: lazyNamed(() => import('./pages/Image/Generator'), 'AiImageGenerator'),
};
